import { ProjectStatus } from 'entities/project';

export const getDefaultProjectStatus = (): ProjectStatus => {
  return 'ACTIVE';
};
